import { formatDate } from '3-foundation/Localization/formatDate';
import { queryCludo, QueryCludoRequestInterface } from '3-foundation/Search/connector';

export const defaultEventsLimit = 12;

export const getEvents = async ({
	filters,
	limit,
	locale,
	siteId,
}: QueryCludoRequestInterface): Promise<{
	items: Content.EventCatalogPageProperties['events'];
	tags: Content.EventCatalogPageProperties['filterTags'];
	totalItems: Content.EventCatalogPageProperties['totalEvents'];
}> => {
	const today = new Date();
	const searchResult = await queryCludo({
		filters: { ...filters, pageType: 'eventPage', fromDate: formatDate({ dateInput: today, mode: 'sort' }) },
		limit: limit ? limit : defaultEventsLimit,
		sort: { 'search-sort': 'asc' },
		locale,
		siteId,
	});
	const { TypedDocuments: items, Facets, TotalDocument } = searchResult ?? {};
	const facets = Facets?.Category?.Items ?? [];
	const events = items?.map((item) => {
		return {
			kicker: item.Fields['search-kicker']?.Value || null,
			title: item.Fields.Title.Value,
			date: {
				label: '',
				value: item.Fields['search-date'].Value || null,
			},
			location: {
				label: '',
				value: item.Fields['search-location']?.Value || null,
			},
			price: {
				label: '',
				value: item.Fields['search-price']?.Value || null,
			},
			link: {
				name: '',
				url: item.Fields.Url.Value,
			},
		};
	});

	const tags = facets
		?.map((tag) => {
			return { name: tag.Key, count: tag.Count };
		})
		.filter((tag) => tag.name !== 'Other');
	return { items: events, tags, totalItems: TotalDocument };
};
